"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _store = _interopRequireDefault(require("@/store"));

var _moment = _interopRequireDefault(require("moment"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiAffaireCalculs = _interopRequireWildcard(require("@/api/affairecalculs"));

var apiSociete = _interopRequireWildcard(require("@/api/societe"));

var apiClient = _interopRequireWildcard(require("@/api/client"));

var apiEnseigne = _interopRequireWildcard(require("@/api/enseigne"));

var apiUser = _interopRequireWildcard(require("@/api/user"));

var apiSecteurAct = _interopRequireWildcard(require("@/api/secteuract"));

var apiSecteurGeo = _interopRequireWildcard(require("@/api/secteurgeo"));

var apiLot = _interopRequireWildcard(require("@/api/lot"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

var apiHistorique = _interopRequireWildcard(require("@/api/historique"));

var apiAvenant = _interopRequireWildcard(require("@/api/avenant"));

var apiAvenantMarchePrincipalEntete = _interopRequireWildcard(require("@/api/avenant_mprinc"));

var apiProvision = _interopRequireWildcard(require("@/api/provision"));

var apiProvisionRisque = _interopRequireWildcard(require("@/api/provision_risque"));

var apiTransfert = _interopRequireWildcard(require("@/api/transfert"));

var apiBudgetComp = _interopRequireWildcard(require("@/api/budgetcomp"));

var apiGestMensLotDetail = _interopRequireWildcard(require("@/api/gestmens_lotdetail"));

var apiGestMensAffaire = _interopRequireWildcard(require("@/api/gestmens_affaire"));

var apiAffaireHistorique = _interopRequireWildcard(require("@/api/affaire_historique"));

var _utils = require("@/helpers/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var state = {
  affaires: [],
  affaire: {},
  lots: [],
  lotsDetail: [],
  avenants: [],
  avenantsMarchePrincipalEntetes: [],
  avenantsMarchePrincipal: [],
  budgetscomp: [],
  provisions: [],
  provisionsRisques: [],
  transferts: [],
  // gestmensFacture: [],
  gestmensLotDetail: [],
  gestmensAffaire: [],
  calculsMmoins1: [],
  // --
  nbColAvenant: 0,
  nbColAvenantMarchePrincipal: 0,
  nbColBudgetComp: 0,
  nbColProvision: 0,
  nbColProvisionRisque: 0,
  nbColTransfert: 0,
  currentGestMensYYYYMM: null,
  lastGestMens: null,
  histoLastGestMens: null,
  // ---
  secteurGeo: [],
  secteurAct: [],
  client: [],
  enseigne: [],
  // ---
  user: [],
  ingenieurEtude: [],
  chefProjet: [],
  conducteurTravaux: [],
  // ---
  calculs: []
};
var mutations = {
  SET_STATE: function SET_STATE(state, data) {
    Object.assign(state, data);
  },
  // --- AFFAIRES --- //
  SET_AFFAIRE: function SET_AFFAIRE(state, affaire) {
    state.affaire = affaire; // console.log('MUTATION->SET_AFFAIRE : state.affaire', state.affaire)
  },
  // --- AFFAIRES --- //
  SET_AFFAIRES: function SET_AFFAIRES(sate, affaires) {
    state.affaires = affaires; // console.log('MUTATION->SET_AFFAIRES : state.affaires', state.affaires)
  },
  // --- LOTS --- //
  ADD_LOT: function ADD_LOT(state, lot) {
    state.lots.push(lot);
  },
  UPD_LOT: function UPD_LOT(state, lot) {
    var index = state.lots.findIndex(function (x) {
      return x.id === lot.id;
    });
    state.lots[index] = lot;
  },
  DEL_LOT: function DEL_LOT(state, lot) {
    var index = state.lots.findIndex(function (x) {
      return x.id === lot.id;
    });
    state.lots.splice(index, 1);
  },
  // --- DETAIL LOTS --- //
  ADD_LOT_DETAIL: function ADD_LOT_DETAIL(state, detail) {
    state.lotsDetail.push(detail);
  },
  UPD_LOT_DETAIL: function UPD_LOT_DETAIL(state, detail) {
    var index = state.lotsDetail.findIndex(function (x) {
      return x.id === detail.id;
    });
    state.lotsDetail[index] = detail;
  },
  DEL_LOT_DETAIL: function DEL_LOT_DETAIL(state, detail) {
    var index = state.lotsDetail.findIndex(function (x) {
      return x.id === detail.id;
    });
    state.lotsDetail.splice(index, 1);
  },
  // --- AVENANTS --- //
  ADD_AVENANT: function ADD_AVENANT(state, avenant) {
    state.avenants.push(avenant);
  },
  UPD_AVENANT: function UPD_AVENANT(state, avenant) {
    var index = state.avenants.findIndex(function (x) {
      return x.num_colonne === avenant.num_colonne && x.id_lot_detail === avenant.id_lot_detail;
    });

    if (index >= 0) {
      state.avenants[index] = avenant;
    } else {
      state.avenants.push(avenant);
    }
  },
  DEL_ALLAVENANT_BY_NUMCOL: function DEL_ALLAVENANT_BY_NUMCOL(state, numColonne) {
    var avenants = state.avenants.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    avenants.forEach(function (avenant) {
      var index = state.avenants.findIndex(function (x) {
        return x.num_colonne === avenant.num_colonne && x.id_lot_detail === avenant.id_lot_detail;
      });
      state.avenants.splice(index, 1);
    });
  },
  // --- AVENANTS MARCHE PRINCIPAL ENTETE --- //
  ADD_AVENANT_MARCHE_PRINCIPAL_ENTETE: function ADD_AVENANT_MARCHE_PRINCIPAL_ENTETE(state, avenant) {
    state.avenantsMarchePrincipalEntetes.push(avenant);
    state.nbColAvenantMarchePrincipal++;
  },
  UPD_AVENANT_MARCHE_PRINCIPAL_ENTETE: function UPD_AVENANT_MARCHE_PRINCIPAL_ENTETE(state, avenant) {
    var index = state.avenantsMarchePrincipalEntetes.findIndex(function (x) {
      return x.id === avenant.id;
    });

    if (index >= 0) {
      state.avenantsMarchePrincipalEntetes[index] = avenant;
    }
  },
  // --- AVENANTS MARCHE PRINCIPAL --- //
  ADD_AVENANT_MARCHE_PRINCIPAL: function ADD_AVENANT_MARCHE_PRINCIPAL(state, avenant) {
    state.avenantsMarchePrincipal.push(avenant);
  },
  UPD_AVENANT_MARCHE_PRINCIPAL: function UPD_AVENANT_MARCHE_PRINCIPAL(state, avenant) {
    var index = state.avenantsMarchePrincipal.findIndex(function (x) {
      return x.num_colonne === avenant.num_colonne && x.id_lot_detail === avenant.id_lot_detail;
    });

    if (index >= 0) {
      state.avenantsMarchePrincipal[index] = avenant;
    } else {
      state.avenantsMarchePrincipal.push(avenant);
    }
  },
  DEL_AVENANT_MARCHE_PRINCIPAL: function DEL_AVENANT_MARCHE_PRINCIPAL(state, avenant) {
    var index = state.avenantsMarchePrincipal.findIndex(function (x) {
      return x.num_colonne === avenant.num_colonne && x.id_lot_detail === avenant.id_lot_detail;
    });

    if (index >= 0) {
      state.avenantsMarchePrincipal.splice(index, 1);
    }
  },
  DEL_ALLAVENANT_MARCHE_PRINCIPAL_BY_NUMCOL: function DEL_ALLAVENANT_MARCHE_PRINCIPAL_BY_NUMCOL(state, numColonne) {
    var avenants = state.avenantsMarchePrincipal.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    avenants.forEach(function (avenant) {
      var index = state.avenantsMarchePrincipal.findIndex(function (x) {
        return x.num_colonne === avenant.num_colonne && x.id_lot_detail === avenant.id_lot_detail;
      });
      state.avenantsMarchePrincipal.splice(index, 1);
    });
  },
  // --- BUDGET COMP --- //
  ADD_BUDGETCOMP: function ADD_BUDGETCOMP(state, budgetcomp) {
    state.budgetscomp.push(budgetcomp);
  },
  UPD_BUDGETCOMP: function UPD_BUDGETCOMP(state, budgetcomp) {
    var index = state.budgetscomp.findIndex(function (x) {
      return x.num_colonne === budgetcomp.num_colonne && x.id_lot_detail === budgetcomp.id_lot_detail;
    });

    if (index >= 0) {
      state.budgetscomp[index] = budgetcomp;
    } else {
      state.budgetscomp.push(budgetcomp);
    }
  },
  DEL_ALLBUDGETCOMP_BY_NUMCOL: function DEL_ALLBUDGETCOMP_BY_NUMCOL(state, numColonne) {
    var budgetscomp = state.budgetscomp.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    budgetscomp.forEach(function (budgetcomp) {
      var index = state.budgetscomp.findIndex(function (x) {
        return x.num_colonne === budgetcomp.num_colonne && x.id_lot_detail === budgetcomp.id_lot_detail;
      });
      state.budgetscomp.splice(index, 1);
    });
  },
  // --- PROVISION --- //
  ADD_PROVISION: function ADD_PROVISION(state, provision) {
    state.provisions.push(provision);
  },
  UPD_PROVISION: function UPD_PROVISION(state, provision) {
    var index = state.provisions.findIndex(function (x) {
      return x.num_colonne === provision.num_colonne && x.id_lot_detail === provision.id_lot_detail;
    });

    if (index >= 0) {
      state.provisions[index] = provision;
    } else {
      state.provisions.push(provision);
    }
  },
  DEL_ALLPROVISION_BY_NUMCOL: function DEL_ALLPROVISION_BY_NUMCOL(state, numColonne) {
    var provisions = state.provisions.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    provisions.forEach(function (provision) {
      var index = state.provisions.findIndex(function (x) {
        return x.num_colonne === provision.num_colonne && x.id_lot_detail === provision.id_lot_detail;
      });
      state.provisions.splice(index, 1);
    });
  },
  // --- PROVISION POUR RISQUES--- //
  ADD_PROVISIONRISQUE: function ADD_PROVISIONRISQUE(state, provision) {
    state.provisionsRisques.push(provision);
  },
  UPD_PROVISIONRISQUE: function UPD_PROVISIONRISQUE(state, provision) {
    var index = state.provisionsRisques.findIndex(function (x) {
      return x.num_colonne === provision.num_colonne && x.id_lot_detail === provision.id_lot_detail;
    });

    if (index >= 0) {
      state.provisionsRisques[index] = provision;
    } else {
      state.provisionsRisques.push(provision);
    }
  },
  DEL_ALLPROVISIONRISQUE_BY_NUMCOL: function DEL_ALLPROVISIONRISQUE_BY_NUMCOL(state, numColonne) {
    var provisionsRisques = state.provisions.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    provisionsRisques.forEach(function (provision) {
      var index = state.provisionsRisques.findIndex(function (x) {
        return x.num_colonne === provision.num_colonne && x.id_lot_detail === provision.id_lot_detail;
      });
      state.provisionsRisques.splice(index, 1);
    });
  },
  // --- TRANSFERT --- //
  ADD_TRANSFERT: function ADD_TRANSFERT(state, transfert) {
    state.transferts.push(transfert);
  },
  UPD_TRANSFERT: function UPD_TRANSFERT(state, transfert) {
    var index = state.transferts.findIndex(function (x) {
      return x.num_colonne === transfert.num_colonne && x.id_lot_detail === transfert.id_lot_detail;
    });

    if (index >= 0) {
      state.transferts[index] = transfert;
    } else {
      state.transferts.push(transfert);
    }
  },
  DEL_ALLTRANSFERT_BY_NUMCOL: function DEL_ALLTRANSFERT_BY_NUMCOL(state, numColonne) {
    var transferts = state.transferts.filter(function (x) {
      return x.num_colonne === numColonne;
    });
    transferts.forEach(function (transfert) {
      var index = state.transferts.findIndex(function (x) {
        return x.num_colonne === transfert.num_colonne && x.id_lot_detail === transfert.id_lot_detail;
      });
      state.transferts.splice(index, 1);
    });
  },
  // --- GESTION MENSUELLE --- //
  ADD_GESTMENS_LOTDETAIL: function ADD_GESTMENS_LOTDETAIL(state, row) {
    state.gestmensLotDetail.push(row);
  },
  UPD_GESTMENS_LOTDETAIL: function UPD_GESTMENS_LOTDETAIL(state, row) {
    var index = state.gestmensLotDetail.findIndex(function (x) {
      return x.id_lot_detail === row.id_lot_detail && x.anneemois === row.anneemois;
    });

    if (index >= 0) {
      state.gestmensLotDetail[index] = row;
    } else {
      state.gestmensLotDetail.push(row);
    }
  },
  ADD_GESTMENS_AFFAIRE: function ADD_GESTMENS_AFFAIRE(state, row) {
    state.gestmensAffaire.push(row);
  },
  UPD_GESTMENS_AFFAIRE: function UPD_GESTMENS_AFFAIRE(state, row) {
    var index = state.gestmensAffaire.findIndex(function (x) {
      return x.anneemois === row.anneemois;
    });

    if (index >= 0) {
      state.gestmensAffaire[index] = row;
    } else {
      state.gestmensAffaire.push(row);
    }
  },
  // --- HISTORIQUE --- //
  UPD_PERIODE_GESTMENS: function UPD_PERIODE_GESTMENS(state, periode) {
    state.currentGestMensYYYYMM = periode;
  }
};
var actions = {
  /* ---------------------------------------
   *  Liste des affaires
   * ---------------------------------------
   *  Chargement de toutes les affaires.
   */
  getAffaires: function getAffaires(_ref) {
    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    var user = rootGetters.user; // console.log('ACTIONS->getAffaires : user', user)

    return apiAffaire.getAllBySocieteIdAndUserRole(user).then(function (results) {
      commit('SET_AFFAIRES', results);
    });
  },
  getAffaire: function () {
    var _getAffaire = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2, idAffaire) {
      var commit, dispatch, affaire, societe, client, enseigne, secteurAct, secteurGeo, lots, lotsDetail, avenantsMarchePrincipalEntetes, allAvenants, avenants, avenantsMarchePrincipal, nbColAvenant, nbColAvenantMarchePrincipal, budgetscomp, nbColBudgetComp, provisions, nbColProvision, provisionsRisques, nbColProvisionRisque, transferts, nbColTransfert, users, gestmensLotDetail, gestmensAffaire, currentGestMensYYYYMM;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit, dispatch = _ref2.dispatch;
              _context.prev = 1;
              _context.next = 4;
              return apiAffaire.getById(idAffaire).then(function (results) {
                return results[0];
              });

            case 4:
              affaire = _context.sent;
              _context.next = 7;
              return apiSociete.getById(Number(affaire.id_societe)).then(function (results) {
                return results[0];
              });

            case 7:
              societe = _context.sent;
              _context.next = 10;
              return apiClient.getById(Number(affaire.id_client)).then(function (results) {
                return results[0];
              });

            case 10:
              client = _context.sent;
              _context.next = 13;
              return apiEnseigne.getById(Number(affaire.id_enseigne)).then(function (results) {
                return results[0];
              });

            case 13:
              enseigne = _context.sent;
              _context.next = 16;
              return apiSecteurAct.getById(Number(affaire.id_secteur_act)).then(function (results) {
                return results[0];
              });

            case 16:
              secteurAct = _context.sent;
              _context.next = 19;
              return apiSecteurGeo.getById(Number(affaire.id_secteur_geo)).then(function (results) {
                return results[0];
              });

            case 19:
              secteurGeo = _context.sent;
              _context.next = 22;
              return apiLot.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 22:
              lots = _context.sent;
              _context.next = 25;
              return apiLotDetail.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 25:
              lotsDetail = _context.sent;
              _context.next = 28;
              return apiAvenantMarchePrincipalEntete.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 28:
              avenantsMarchePrincipalEntetes = _context.sent;
              _context.next = 31;
              return apiAvenant.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 31:
              allAvenants = _context.sent;
              avenants = allAvenants.filter(function (x) {
                return x.id_avenant_mprinc === null;
              });
              avenantsMarchePrincipal = allAvenants.filter(function (x) {
                return x.id_avenant_mprinc !== null;
              });
              nbColAvenant = avenants.length > 0 ? Math.max.apply(Math, avenants.map(function (o) {
                return o.num_colonne;
              })) : 0;
              nbColAvenantMarchePrincipal = avenantsMarchePrincipal.length > 0 ? Math.max.apply(Math, avenantsMarchePrincipal.map(function (o) {
                return o.num_colonne;
              })) : 0; // --

              _context.next = 38;
              return apiBudgetComp.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 38:
              budgetscomp = _context.sent;
              nbColBudgetComp = budgetscomp.length > 0 ? Math.max.apply(Math, budgetscomp.map(function (o) {
                return o.num_colonne;
              })) : 0; // --

              _context.next = 42;
              return apiProvision.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 42:
              provisions = _context.sent;
              nbColProvision = provisions.length > 0 ? Math.max.apply(Math, provisions.map(function (o) {
                return o.num_colonne;
              })) : 0; // --

              _context.next = 46;
              return apiProvisionRisque.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 46:
              provisionsRisques = _context.sent;
              nbColProvisionRisque = provisionsRisques.length > 0 ? Math.max.apply(Math, provisionsRisques.map(function (o) {
                return o.num_colonne;
              })) : 0; // --

              _context.next = 50;
              return apiTransfert.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 50:
              transferts = _context.sent;
              nbColTransfert = transferts.length > 0 ? Math.max.apply(Math, transferts.map(function (o) {
                return o.num_colonne;
              })) : 0; // --

              _context.next = 54;
              return apiUser.getAllBySocieteId(affaire.id_societe).then(function (results) {
                var creator = results.find(function (x) {
                  return x.id === affaire.id_user;
                });
                var ingenieurEtude = results.find(function (x) {
                  return x.id === affaire.id_ingenieur_etude;
                });
                var chefProjet = results.find(function (x) {
                  return x.id === affaire.id_chef_projet;
                });
                var conducteurTravaux = results.find(function (x) {
                  return x.id === affaire.id_conducteur_travaux;
                });
                var directeurExploitation = results.find(function (x) {
                  return x.key_role === 'de';
                });
                var responsableSecteur = results.find(function (x) {
                  return x.id === affaire.id_responsable_secteur;
                });
                var assistanteDirection = results.find(function (x) {
                  return x.key_role === 'adir';
                });
                return {
                  creator: creator,
                  ingenieurEtude: ingenieurEtude,
                  chefProjet: chefProjet,
                  conducteurTravaux: conducteurTravaux,
                  directeurExploitation: directeurExploitation,
                  responsableSecteur: responsableSecteur,
                  assistanteDirection: assistanteDirection
                };
              });

            case 54:
              users = _context.sent;
              _context.next = 57;
              return apiGestMensLotDetail.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 57:
              gestmensLotDetail = _context.sent;
              _context.next = 60;
              return apiGestMensAffaire.getAllByAffaireId(affaire.id).then(function (results) {
                return results;
              });

            case 60:
              gestmensAffaire = _context.sent;
              _context.next = 63;
              return apiHistorique.getCurrentPeriodeGestMensByAffaireId(affaire.id).then(function (result) {
                return result && result[0] ? result[0].YYYYMM : null;
              });

            case 63:
              currentGestMensYYYYMM = _context.sent;
              // TODO Il est préférable de laisser les MUTATIONS manipuler le store et non pas les ACTIONS
              // state.affaire = affaire
              commit('SET_AFFAIRE', affaire);
              state.lots = lots;
              state.lotsDetail = lotsDetail;
              state.avenants = avenants;
              state.nbColAvenant = nbColAvenant;
              state.avenantsMarchePrincipalEntetes = avenantsMarchePrincipalEntetes;
              state.avenantsMarchePrincipal = avenantsMarchePrincipal;
              state.nbColAvenantMarchePrincipal = nbColAvenantMarchePrincipal;
              state.budgetscomp = budgetscomp;
              state.nbColBudgetComp = nbColBudgetComp;
              state.provisions = provisions;
              state.nbColProvision = nbColProvision;
              state.provisionsRisques = provisionsRisques;
              state.nbColProvisionRisque = nbColProvisionRisque;
              state.transferts = transferts;
              state.nbColTransfert = nbColTransfert;
              state.societe = societe;
              state.user = users.creator;
              state.ingenieurEtude = users.ingenieurEtude;
              state.chefProjet = users.chefProjet;
              state.conducteurTravaux = users.conducteurTravaux;
              state.directeurExploitation = users.directeurExploitation;
              state.responsableSecteur = users.responsableSecteur;
              state.assistanteDirection = users.assistanteDirection;
              state.client = client;
              state.enseigne = enseigne;
              state.secteurAct = secteurAct;
              state.secteurGeo = secteurGeo;
              state.gestmensLotDetail = gestmensLotDetail;
              state.gestmensAffaire = gestmensAffaire;
              state.currentGestMensYYYYMM = currentGestMensYYYYMM; // --

              state.YYYYMM = null;
              state.YYYYMMmoins1 = null;
              state.YYYYMMmoins2 = null;
              state.lastGestMens = null; // L'action est déléguée au store facturation

              _context.next = 101;
              return dispatch('facturation/init', null, {
                root: true
              });

            case 101:
              return _context.abrupt("return", true);

            case 104:
              _context.prev = 104;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", new Error(_context.t0));

            case 107:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 104]]);
    }));

    function getAffaire(_x, _x2) {
      return _getAffaire.apply(this, arguments);
    }

    return getAffaire;
  }(),
  // --- GESTION AFFAIRE --- //
  getAffaireById: function getAffaireById(_ref3, idAffaire) {
    var dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      dispatch('getAffaire', idAffaire).then(function (result) {
        if (result === true) {
          resolve();
        } else {
          reject(result);
        }
      });
    });
  },
  updateAffaire: function updateAffaire(_ref4, affaire) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      apiAffaire.update(affaire.id, affaire.data).then(function (results) {
        // dispatch('saveToDb')
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // --- GESTION LOTS --- //
  insertLot: function insertLot(_ref5, lot) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      apiLot.insert(lot).then(function (results) {
        lot.id = results.insertId;
        commit('ADD_LOT', lot);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateLot: function updateLot(_ref6, lot) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      apiLot.update(lot.id, lot).then(function (results) {
        commit('UPD_LOT', lot);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteLot: function deleteLot(_ref7, lot) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      apiLot.deleteById(lot.id).then(function (results) {
        commit('DEL_LOT', lot);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // --- GESTION DETAILS LOT --- //
  insertLotDetail: function insertLotDetail(_ref8, lotdetail) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      apiLotDetail.insert(lotdetail).then(function (results) {
        lotdetail.id = results.insertId;
        commit('ADD_LOT_DETAIL', lotdetail);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateLotDetail: function updateLotDetail(_ref9, lotdetail) {
    var dispatch = _ref9.dispatch;
    return new Promise(function (resolve, reject) {
      apiLotDetail.update(lotdetail.id, lotdetail).then(function (results) {
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  deleteLotDetail: function deleteLotDetail(_ref10, lotdetail) {
    var commit = _ref10.commit;
    return new Promise(function (resolve, reject) {
      apiLotDetail.deleteById(lotdetail.id).then(function (results) {
        commit('DEL_LOT_DETAIL', lotdetail);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setLotDetail: function setLotDetail(_ref11, lotdetail) {
    var commit = _ref11.commit;
    return new Promise(function (resolve) {
      commit('UPD_LOT_DETAIL', lotdetail);
      resolve();
    });
  },
  // --- GESTION AVENANT --- //
  insertAvenant: function insertAvenant(_ref12, avenant) {
    var commit = _ref12.commit;
    return new Promise(function (resolve, reject) {
      apiAvenant.insert(avenant).then(function (results) {
        avenant.id = results.insertId;
        commit('UPD_AVENANT', avenant);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setAvenant: function setAvenant(_ref13, avenant) {
    var commit = _ref13.commit;
    return new Promise(function (resolve) {
      commit('UPD_AVENANT', avenant);
      resolve();
    });
  },
  // --- GESTION ENTETE AVENANT MARCHE PRINCIPAL--- //
  insertAvenantMarchePrincipalEntete: function insertAvenantMarchePrincipalEntete(_ref14, avenant) {
    var commit = _ref14.commit;
    return new Promise(function (resolve, reject) {
      apiAvenantMarchePrincipalEntete.insert(avenant).then(function (results) {
        avenant.id = results.insertId;
        commit('ADD_AVENANT_MARCHE_PRINCIPAL_ENTETE', avenant);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateAvenantMarchePrincipalEntete: function updateAvenantMarchePrincipalEntete(_ref15, avenant) {
    var commit = _ref15.commit;
    return new Promise(function (resolve, reject) {
      apiAvenantMarchePrincipalEntete.update(avenant.id, avenant).then(function (results) {
        commit('UPD_AVENANT_MARCHE_PRINCIPAL_ENTETE', avenant);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // --- GESTION AVENANT MARCHE PRINCIPAL--- //
  insertAvenantMarchePrincipal: function insertAvenantMarchePrincipal(_ref16, data) {
    var commit = _ref16.commit;

    var _data = _slicedToArray(data, 2),
        avenant = _data[0],
        idLot = _data[1];

    return new Promise(function (resolve, reject) {
      apiAvenant.insert(avenant).then(function (results) {
        avenant.id = results.insertId;
        avenant.id_lot = idLot;
        commit('UPD_AVENANT_MARCHE_PRINCIPAL', avenant);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateAvenantMarchePrincipal: function updateAvenantMarchePrincipal(_ref17, data) {
    var commit = _ref17.commit;

    var _data2 = _slicedToArray(data, 2),
        avenant = _data2[0],
        idLot = _data2[1];

    return new Promise(function (resolve, reject) {
      apiAvenant.update(avenant.id, avenant).then(function (results) {
        avenant.id_lot = idLot;
        commit('UPD_AVENANT_MARCHE_PRINCIPAL', avenant);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setAvenantMarchePrincipal: function setAvenantMarchePrincipal(_ref18, avenant) {
    var commit = _ref18.commit;
    return new Promise(function (resolve) {
      commit('UPD_AVENANT_MARCHE_PRINCIPAL', avenant);
      resolve();
    });
  },
  delAvenantMarchePrincipal: function delAvenantMarchePrincipal(_ref19, avenant) {
    var commit = _ref19.commit;
    return new Promise(function (resolve) {
      commit('DEL_AVENANT_MARCHE_PRINCIPAL', avenant);
      resolve();
    });
  },
  // --- GESTION BUDGET COMP --- //
  insertBudgetComp: function insertBudgetComp(_ref20, budgetcomp) {
    var commit = _ref20.commit;
    return new Promise(function (resolve, reject) {
      apiBudgetComp.insert(budgetcomp).then(function (results) {
        budgetcomp.id = results.insertId;
        commit('UPD_BUDGETCOMP', budgetcomp);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setBudgetComp: function setBudgetComp(_ref21, budgetcomp) {
    var commit = _ref21.commit;
    return new Promise(function (resolve) {
      commit('UPD_BUDGETCOMP', budgetcomp);
      resolve();
    });
  },
  // --- GESTION PROVISION --- //
  insertProvision: function insertProvision(_ref22, provision) {
    var commit = _ref22.commit;
    return new Promise(function (resolve, reject) {
      apiProvision.insert(provision).then(function (results) {
        provision.id = results.insertId;
        commit('UPD_PROVISION', provision);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setProvision: function setProvision(_ref23, provision) {
    var commit = _ref23.commit;
    return new Promise(function (resolve) {
      commit('UPD_PROVISION', provision);
      resolve();
    });
  },
  // --- GESTION PROVISION POUR RISQUES --- //
  insertProvisionRisque: function insertProvisionRisque(_ref24, provision) {
    var commit = _ref24.commit;
    return new Promise(function (resolve, reject) {
      apiProvisionRisque.insert(provision).then(function (results) {
        provision.id = results.insertId;
        commit('UPD_PROVISIONRISQUE', provision);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setProvisionRisque: function setProvisionRisque(_ref25, provision) {
    var commit = _ref25.commit;
    return new Promise(function (resolve) {
      commit('UPD_PROVISIONRISQUE', provision);
      resolve();
    });
  },
  // --- GESTION TRANSFERT --- //
  insertTransfert: function insertTransfert(_ref26, transfert) {
    var commit = _ref26.commit;
    return new Promise(function (resolve, reject) {
      apiTransfert.insert(transfert).then(function (results) {
        transfert.id = results.insertId;
        commit('UPD_TRANSFERT', transfert);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setTransfert: function setTransfert(_ref27, transfert) {
    var commit = _ref27.commit;
    return new Promise(function (resolve) {
      commit('UPD_TRANSFERT', transfert);
      resolve();
    });
  },
  // --- GESTION HISTORIQUE --- //
  setHistorique: function setHistorique(_ref28, infos) {
    var _ = _ref28._;
    return new Promise(function (resolve, reject) {
      var data = {
        id_affaire: infos.id,
        id_user: _store.default.getters.user.id,
        status: infos.status,
        etape: infos.etape,
        message: infos.message || '',
        data: infos.data || ''
      };
      apiHistorique.insert(data).then(function () {
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updatePeriodeGestMens: function updatePeriodeGestMens(_ref29, idAffaire) {
    var commit = _ref29.commit;
    return new Promise(function (resolve, reject) {
      apiHistorique.getCurrentPeriodeGestMensByAffaireId(idAffaire).then(function (result) {
        var periode = result && result[0] ? result[0].YYYYMM : null;
        commit('UPD_PERIODE_GESTMENS', periode);
        resolve(periode);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // --- GESTION MENSUELLE --- //
  // gestmens_lotdetail
  insertGestMensLotDetail: function insertGestMensLotDetail(_ref30, row) {
    var commit = _ref30.commit;
    return new Promise(function (resolve, reject) {
      apiGestMensLotDetail.insert(row).then(function (results) {
        row.id = results.insertId;
        commit('UPD_GESTMENS_LOTDETAIL', row);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateGestMensLotDetail: function updateGestMensLotDetail(_ref31, row) {
    var dispatch = _ref31.dispatch;
    return new Promise(function (resolve, reject) {
      apiGestMensLotDetail.update(row.id, row).then(function (results) {
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  setGestMensLotDetail: function setGestMensLotDetail(_ref32, row) {
    var commit = _ref32.commit;
    return new Promise(function (resolve) {
      commit('UPD_GESTMENS_LOTDETAIL', row);
      resolve();
    });
  },
  cancelGestMensLotDetail: function cancelGestMensLotDetail(_ref33) {
    var commit = _ref33.commit;
    // on nettoie les lignes de state.gestmensLotDetail dont l'id === null
    // pour annuler les éventuelles saisies
    return new Promise(function (resolve) {
      var tmp = [];
      state.gestmensLotDetail.forEach(function (x) {
        if (x.id !== null) {
          tmp.push(x);
        }
      });
      state.gestmensLotDetail = tmp;
      resolve();
    });
  },
  // gestmens_affaire
  insertGestMensAffaire: function insertGestMensAffaire(_ref34, row) {
    var commit = _ref34.commit;
    return new Promise(function (resolve, reject) {
      apiGestMensAffaire.insert(row).then(function (results) {
        row.id = row.insertId;
        commit('UPD_GESTMENS_AFFAIRE', row);
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
      resolve();
    });
  },
  updateGestMensAffaire: function updateGestMensAffaire(_ref35, row) {
    var dispatch = _ref35.dispatch;
    return new Promise(function (resolve, reject) {
      apiGestMensAffaire.update(row.id, row).then(function (results) {
        resolve(results);
      }).catch(function (error) {
        reject(error);
      });
      resolve();
    });
  },
  setGestMensAffaire: function setGestMensAffaire(_ref36, row) {
    var commit = _ref36.commit;
    return new Promise(function (resolve) {
      commit('UPD_GESTMENS_AFFAIRE', row);
      resolve();
    });
  },
  cancelGestMensAffaire: function cancelGestMensAffaire(_ref37) {
    var commit = _ref37.commit;
    // on nettoie les lignes de state.gestmensAffaire dont l'id === null
    // pour annuler les éventuelles saisies
    return new Promise(function (resolve) {
      var tmp = [];
      state.gestmensAffaire.forEach(function (x) {
        if (x.id !== null) {
          tmp.push(x);
        }
      });
      state.gestmensAffaire = tmp;
      resolve();
    });
  },
  // ==========================================================
  calcul: function () {
    var _calcul = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref38, _ref39) {
      var dispatch, commit, rootState, params, filtreProvisions, periode, lastGestMens, histoLastGestMens, dateRef, data, users;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch = _ref38.dispatch, commit = _ref38.commit, rootState = _ref38.rootState;
              params = _ref39.params, filtreProvisions = _ref39.filtreProvisions;
              // si le calcul est déclenché par le changement de période à partir du déroulant des dates de gestion mensuelle connues
              // (écran gestion mensuelle en haut à droite)
              // console.log('params', params)
              // const handleChangePeriodeGestMens = (params && params.periode && params.periode !== null) || false
              // initialisation de la période: valeur du déroulant ou valeur par défaut récupérée dans l'historique (derniere gestmens connue)
              periode = params && params.periode && params.periode !== null && params.periode !== '' ? params.periode : state.currentGestMensYYYYMM; // récupération de la derniere date de gestmens connue dans la table affaire_calculs pour l'affaire
              // (photos des données des gestions mensuelles)

              _context2.next = 5;
              return apiAffaireCalculs.getLastGestMens(state.societe.id);

            case 5:
              lastGestMens = _context2.sent;
              lastGestMens = lastGestMens && lastGestMens.length > 0 ? lastGestMens[0].anneemois : null; // récupération de la derniere date de gestmens connue dans la table historique pour l'affaire

              _context2.next = 9;
              return apiHistorique.getCurrentPeriodeGestMensByAffaireId(state.affaire.id).then(function (result) {
                return result && result[0] ? result[0].YYYYMM : null;
              });

            case 9:
              histoLastGestMens = _context2.sent;

              if (!(params && params.modeEdit === false && periode)) {
                _context2.next = 61;
                break;
              }

              if (!(params && params.periode !== '' && params.periode !== null)) {
                _context2.next = 61;
                break;
              }

              // 202401 = date figeage des données de l'exercice 2023 pour gérer le bug de perte des données mensuelles
              dateRef = periode <= '202401' ? '202401' : periode; // console.log(`lastGestMens = ${lastGestMens}, dateRef = ${dateRef},  periode = ${periode},  periode <= '202401 : ${periode <= '202401'}, dateRef >= '202401' : ${dateRef >= '202401'}, lastGestMens = ${lastGestMens}`)

              if (!(dateRef === '202401' || dateRef > '202401' && dateRef < lastGestMens && dateRef < histoLastGestMens)) {
                _context2.next = 58;
                break;
              }

              _context2.next = 16;
              return apiAffaireHistorique.getAffaireHistoByIdAnneeMois(state.affaire.id, dateRef);

            case 16:
              data = _context2.sent;
              console.log("chargement des donn\xE9es \xE0 partir de l'historique de l'affaire | dateRef = ".concat(dateRef));

              if (!(data && data.affaire)) {
                _context2.next = 52;
                break;
              }

              state.affaire = data.affaire;
              state.lots = data.lots;
              state.lotsDetail = data.lotsDetail;
              state.avenants = data.avenants;
              state.avenantsMarchePrincipalEntetes = data.avenantsMarchePrincipalEntetes;
              state.avenantsMarchePrincipal = data.avenantsMarchePrincipal;
              state.budgetscomp = data.budgetsComp;
              state.provisions = data.provisions;
              state.provisionsRisques = data.provisionsRisques;
              state.transferts = data.transferts;
              state.gestmensLotDetail = data.gestmensLotDetail;
              state.gestmensAffaire = data.gestmensAffaire; // --

              state.nbColAvenant = state.avenants.length > 0 ? Math.max.apply(Math, state.avenants.map(function (o) {
                return o.num_colonne;
              })) : 0; // on prends le nombre d'entete et pas le nombre d'avenants mprinc car il peut avoir des entetes sans avenants mprinc

              state.nbColAvenantMarchePrincipal = state.calculs.avenantsMarchePrincipalEntetes.length || 0;
              state.nbColBudgetComp = state.budgetscomp.length > 0 ? Math.max.apply(Math, state.budgetscomp.map(function (o) {
                return o.num_colonne;
              })) : 0;
              state.nbColProvision = state.provisions.length > 0 ? Math.max.apply(Math, state.provisions.map(function (o) {
                return o.num_colonne;
              })) : 0;
              state.nbColProvisionRisque = state.provisionsRisques.length > 0 ? Math.max.apply(Math, state.provisionsRisques.map(function (o) {
                return o.num_colonne;
              })) : 0;
              state.nbColTransfert = state.transferts.length > 0 ? Math.max.apply(Math, state.transferts.map(function (o) {
                return o.num_colonne;
              })) : 0;
              _context2.next = 39;
              return apiHistorique.getCurrentPeriodeGestMensByAffaireId(state.affaire.id).then(function (result) {
                return result && result[0] ? result[0].YYYYMM : null;
              });

            case 39:
              state.currentGestMensYYYYMM = _context2.sent;
              _context2.next = 42;
              return apiUser.getAllBySocieteId(state.affaire.id_societe).then(function (results) {
                var creator = results.find(function (x) {
                  return x.id === state.affaire.id_user;
                });
                var ingenieurEtude = results.find(function (x) {
                  return x.id === state.affaire.id_ingenieur_etude;
                });
                var chefProjet = results.find(function (x) {
                  return x.id === state.affaire.id_chef_projet;
                });
                var conducteurTravaux = results.find(function (x) {
                  return x.id === state.affaire.id_conducteur_travaux;
                });
                var directeurExploitation = results.find(function (x) {
                  return x.key_role === 'de';
                });
                var responsableSecteur = results.find(function (x) {
                  return x.id === state.affaire.id_responsable_secteur;
                });
                var assistanteDirection = results.find(function (x) {
                  return x.key_role === 'adir';
                });
                return {
                  creator: creator,
                  ingenieurEtude: ingenieurEtude,
                  chefProjet: chefProjet,
                  conducteurTravaux: conducteurTravaux,
                  directeurExploitation: directeurExploitation,
                  responsableSecteur: responsableSecteur,
                  assistanteDirection: assistanteDirection
                };
              });

            case 42:
              users = _context2.sent;
              state.creator = users.creator;
              state.ingenieurEtude = users.ingenieurEtude;
              state.chefProjet = users.chefProjet;
              state.conducteurTravaux = users.conducteurTravaux;
              state.directeurExploitation = users.directeurExploitation;
              state.responsableSecteur = users.responsableSecteur;
              state.assistanteDirection = users.assistanteDirection;
              _context2.next = 56;
              break;

            case 52:
              console.log("Affaire non trouv\xE9e dans l'historique pour dateRef = ".concat(dateRef)); // chargement des données de la période de gestion en cours

              console.log("-> chargement des donn\xE9es de la p\xE9riode de gestion en cours | dateRef = ".concat(dateRef));
              _context2.next = 56;
              return dispatch('getAffaireById', state.affaire.id);

            case 56:
              _context2.next = 61;
              break;

            case 58:
              // chargement des données de la période de gestion en cours
              console.log("chargement des donn\xE9es de la p\xE9riode de gestion en cours | dateRef = ".concat(dateRef));
              _context2.next = 61;
              return dispatch('getAffaireById', state.affaire.id);

            case 61:
              // détermination des dates de référence
              state.histoLastGestMens = histoLastGestMens;
              state.lastGestMens = lastGestMens;
              state.YYYYMM = periode;
              state.YYYYMMmoins1 = null;
              state.YYYYMMmoins2 = null;

              if (!(state.YYYYMM !== null)) {
                _context2.next = 75;
                break;
              }

              _context2.next = 69;
              return apiAffaireCalculs.getPreviousPeriodeByAffaireIdAnneeMois(state.affaire.id, state.YYYYMM).then(function (results) {
                return results && results[0] ? results[0].anneemois : '';
              });

            case 69:
              state.YYYYMMmoins1 = _context2.sent;
              state.YYYYMMmoins1 = state.YYYYMMmoins1 === '' ? (0, _moment.default)(state.YYYYMM, 'YYYYMM').subtract(1, 'months').format('YYYYMM') : state.YYYYMMmoins1;
              _context2.next = 73;
              return apiAffaireCalculs.getPreviousPeriodeByAffaireIdAnneeMois(state.affaire.id, state.YYYYMMmoins1).then(function (results) {
                return results && results[0] ? results[0].anneemois : '';
              });

            case 73:
              state.YYYYMMmoins2 = _context2.sent;
              state.YYYYMMmoins2 = state.YYYYMMmoins2 === '' ? (0, _moment.default)(state.YYYYMM, 'YYYYMM').subtract(2, 'months').format('YYYYMM') : state.YYYYMMmoins2;

            case 75:
              // message de controle dans la console js du navigateur
              // , Date Histo=${histoLastGestMens}
              console.log("%c[Affaire: ".concat(state.affaire.id, " : S\xE9lection: ").concat(state.YYYYMMmoins1, " => gestion mensuelle affaire: YYYYMM=").concat(state.YYYYMM, ", YYYYMMmoins1=").concat(state.YYYYMMmoins1, ", YYYYMMmoins2=").concat(state.YYYYMMmoins2, "], Gestion mensuelle en cours de la soci\xE9t\xE9: ").concat(state.lastGestMens), 'color:#008000'); // recherche des données de M-1

              _context2.next = 78;
              return apiAffaireCalculs.getByAffaireIdAnneeMois(state.affaire.id, state.YYYYMMmoins1).then(function (results) {
                return results && results[0] ? JSON.parse(results[0].data) : [];
              });

            case 78:
              state.calculsMmoins1 = _context2.sent;
              return _context2.abrupt("return", new Promise(function (resolve) {
                state.calculs.affaire = [{}];
                state.calculs.lots = [{}];
                state.calculs.lotsDetail = [{}];
                state.calculs.avenants = [{}];
                state.calculs.avenantsMarchePrincipal = [{}];
                state.calculs.avenantsMarchePrincipalEntetes = [{}];
                state.calculs.budgetscomp = [{}];
                state.calculs.provisions = [{}];
                state.calculs.provisionsRisques = [{}];
                state.calculs.transferts = [{}];
                state.calculs.gestmensLotDetail = [];
                state.calculs.gestmensAffaire = [];
                state.calculs.factures = []; // calcul des dates d'alerte si la validation synthèse de gestion n'a pas encore été faire avant d'atteindre M+2
                // const dateFinMplus1 = moment(state.YYYYMM + '01', 'YYYYMMDD').add('2', 'months')
                // state.calculs.affaire.dateLimit2ValidationSynthese = dateFinMplus1.add('-15', 'days').format('YYYYMMDD') // alerte2 = -15  (fin M+1 - 15 jours)
                // state.calculs.affaire.dateLimit1ValidationSynthese = dateFinMplus1.add('-3', 'days').format('YYYYMMDD') // alerte1 = -3 (fin M+1 - 18 jours = alerte1 - alerte2 = -3)
                // console.log(state.calculs.affaire.dateLimit1ValidationSynthese, state.calculs.affaire.dateLimit2ValidationSynthese)
                // variable temporaire pour mémorisée des données calculées dans la table affaire_calculs
                // let tmpCalculsLotsDetail = [{}]

                var tmpCalculsLotsDetailDeboursesIndirects = []; // tri des lots et des lignes de détail

                state.lots.sort(function (a, b) {
                  return a.ordre - b.ordre;
                });
                state.lotsDetail.sort(function (a, b) {
                  return a.ordre - b.ordre;
                }); // calcul du coefficent de remise commerciale

                var mtTotalGeneralVenteInitiale = state.affaire.mt_total_vente_initiale;
                var mtRemiseCommerciale = state.affaire.mt_remise_commerciale;
                var coefRemiseCommerciale = mtTotalGeneralVenteInitiale !== 0 ? Number(mtRemiseCommerciale) / Number(mtTotalGeneralVenteInitiale) : 0; // on applique le filtre de sélection du datepicker pour la periode de gestion mensuelle à visualiser

                if (params && params.periode && params.periode !== null) {
                  if (params.periode >= '202502') {
                    // params.periode >= '202502' si dans le déroulant on a >= 01/2025 (donc à partir de l'année comptable 2025)
                    console.log('Chargement des données (avnts, aleas, bdgs, provs, trfts) à partir de la période de gestmens | dateRef periode = ', params.periode);
                    state.calculs.avenants = state.avenants.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.avenantsMarchePrincipal = state.avenantsMarchePrincipal.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.avenantsMarchePrincipalEntetes = state.avenantsMarchePrincipalEntetes.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.budgetscomp = state.budgetscomp.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.provisions = state.provisions.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.provisionsRisques = state.provisionsRisques.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                    state.calculs.transferts = state.transferts.filter(function (x) {
                      return x.periode_gestmens <= params.periode;
                    });
                  } else {
                    var _periode = (0, _moment.default)(params.periode, 'YYYYMM').format('YYYY-MM-31');

                    console.log('Chargement des données (avnts, aleas, bdgs, provs, trfts) à partir de la date de création:', _periode);
                    state.calculs.avenants = state.avenants.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.avenantsMarchePrincipal = state.avenantsMarchePrincipal.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.avenantsMarchePrincipalEntetes = state.avenantsMarchePrincipalEntetes.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.budgetscomp = state.budgetscomp.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.provisions = state.provisions.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.provisionsRisques = state.provisionsRisques.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                    state.calculs.transferts = state.transferts.filter(function (x) {
                      return x.date_creation.substring(0, 10) <= _periode;
                    });
                  }
                } else {
                  state.calculs.avenants = state.avenants;
                  state.calculs.avenantsMarchePrincipal = state.avenantsMarchePrincipal;
                  state.calculs.avenantsMarchePrincipalEntetes = state.avenantsMarchePrincipalEntetes;
                  state.calculs.budgetscomp = state.budgetscomp;
                  state.calculs.provisions = state.provisions;
                  state.calculs.provisionsRisques = state.provisionsRisques;
                  state.calculs.transferts = state.transferts;
                }

                state.calculs.gestmensLotDetail[state.YYYYMM] = state.gestmensLotDetail.filter(function (x) {
                  return x.anneemois === state.YYYYMM;
                });
                state.calculs.gestmensLotDetail[state.YYYYMMmoins1] = state.gestmensLotDetail.filter(function (x) {
                  return x.anneemois <= state.YYYYMMmoins1;
                });
                state.calculs.gestmensAffaire[state.YYYYMM] = state.gestmensAffaire.filter(function (x) {
                  return x.anneemois === state.YYYYMM;
                })[0] || [];
                state.calculs.gestmensAffaire[state.YYYYMMmoins1] = state.gestmensAffaire.filter(function (x) {
                  return x.anneemois <= state.YYYYMMmoins1;
                }) || []; // Facturation: on utilise les données stockées dans le state du store 'facturation'
                // Facturation client : Cumul M

                state.calculs.factures[state.YYYYMM] = rootState.facturation.factures.filter(function (x) {
                  return x.anneemois <= state.YYYYMM;
                }); // Facturation client : Cumul M-1

                state.calculs.factures[state.YYYYMMmoins1] = rootState.facturation.factures.filter(function (x) {
                  return x.anneemois <= state.YYYYMMmoins1;
                }); // ********************************************* [1] calculs pour chaque ligne de détail des lots ***************************************

                state.lotsDetail.forEach(function (lotsDetail, index) {
                  var calculs = {};
                  calculs.id = lotsDetail.id;
                  calculs.id_lot = lotsDetail.id_lot;
                  calculs.libelle = lotsDetail.libelle;
                  calculs.ordre = lotsDetail.ordre;
                  calculs.validation = lotsDetail.validation;
                  calculs.date_validation = lotsDetail.date_validation;
                  calculs.type_lot_detail = lotsDetail.type_lot_detail; // ===================
                  // page vente initiale
                  // ===================

                  calculs.mtDebourseEtude = lotsDetail.mt_debourse_etude || 0; // =========================
                  // page objectifs déboursés
                  // =========================

                  calculs.coefObjectifDebourse = lotsDetail.coef_objectif_debourse || 0;
                  calculs.mtObjDebourseExec = (calculs.mtDebourseEtude * calculs.coefObjectifDebourse).toFixed(2) || 0;
                  calculs.prestataire = lotsDetail.prestataire ? lotsDetail.prestataire.toUpperCase() : lotsDetail.prestataire; // ====================
                  // page budget affaire
                  // ====================

                  calculs.validation = lotsDetail.validation;
                  calculs.mtDernierePropositionPresta = lotsDetail.mt_proposition_prestataire;
                  calculs.mtEcart = calculs.mtDernierePropositionPresta - calculs.mtObjDebourseExec || 0; // =================
                  // page avenants
                  // =================
                  // -> mt avenant

                  var avenants = state.calculs.avenants.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtAvenant = [];
                  avenants.forEach(function (avenant) {
                    calculs.mtAvenant[avenant.num_colonne] = avenant;
                  });
                  var avenantsMarchePrincipal = state.calculs.avenantsMarchePrincipal.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtAvenantMarchePrincipal = [];
                  avenantsMarchePrincipal.forEach(function (avenant) {
                    calculs.mtAvenantMarchePrincipal[avenant.num_colonne] = avenant;
                  }); // -> total des avenants sur la ligne de detail du lot

                  calculs.mtTotalLotDetailLigneAvenant = avenants.length > 0 ? avenants.reduce(function (prev, cur) {
                    return prev + Number(cur.mt_avenant);
                  }, 0) : '';
                  calculs.mtTotalLotDetailLigneAvenantMarchePrincipal = avenantsMarchePrincipal.length > 0 ? avenantsMarchePrincipal.reduce(function (prev, cur) {
                    return prev + Number(cur.mt_avenant);
                  }, 0) : ''; // =================
                  // page budgets complémentaires
                  // =================
                  // -> mt budget_complementaire

                  var budgetscomp = state.calculs.budgetscomp.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtBudgetComp = [];
                  budgetscomp.forEach(function (budgetcomp) {
                    calculs.mtBudgetComp[budgetcomp.num_colonne] = budgetcomp;
                  }); // -> total des budgets complémentaires sur la ligne de detail du lot

                  calculs.mtTotalLotDetailLigneBudgetComp = budgetscomp.length > 0 ? budgetscomp.reduce(function (prev, cur) {
                    return prev + Number(cur.mt_budget_complementaire);
                  }, 0) : ''; // =================
                  // page provisions
                  // =================
                  // -> mt provision

                  var provisions = state.calculs.provisions.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtProvision = [];
                  provisions.forEach(function (provision) {
                    calculs.mtProvision[provision.num_colonne] = provision;
                  }); // -> total des provisions sur la ligne de detail du lot

                  calculs.mtTotalLotDetailLigneProvision = provisions.length > 0 ? provisions.reduce(function (prev, cur) {
                    if (filtreProvisions > 0) {
                      // return cur.etape_origine === filtreProvisions ? prev + Number(cur.mt_provision) : ''
                      return cur.etape_origine <= filtreProvisions ? prev + Number(cur.mt_provision) : '';
                    } else {
                      return prev + Number(cur.mt_provision);
                    }
                  }, 0) : ''; // =================
                  // page provisions pour risques
                  // =================
                  // -> mt provision pour risque

                  var provisionsRisques = state.calculs.provisionsRisques.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtProvisionRisque = [];
                  provisionsRisques.forEach(function (provision) {
                    calculs.mtProvisionRisque[provision.num_colonne] = provision;
                  }); // -> total des provisions sur risques sur la ligne de detail du lot

                  calculs.mtTotalLotDetailLigneProvisionRisque = provisionsRisques.length > 0 ? provisionsRisques.reduce(function (prev, cur) {
                    return prev + Number(cur.mt_provisionrisque);
                  }, 0) : ''; // =================
                  // page transferts
                  // =================
                  // -> mt transfert

                  var transferts = state.calculs.transferts.filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  calculs.mtTransfert = [];
                  transferts.forEach(function (transfert) {
                    calculs.mtTransfert[transfert.num_colonne] = transfert;
                  }); // -> total des transferts sur la ligne de detail du lot

                  calculs.mtTotalLotDetailLigneTransfert = transferts.length > 0 ? transferts.reduce(function (prev, cur) {
                    return prev + Number(cur.mt_transfert);
                  }, 0) : '';
                  calculs.mtTotalLotDetailLigneTransfert = Number(calculs.mtTotalLotDetailLigneTransfert).toFixed(2); // SFI 17/10/2025 probleme d'arrondi sans le toFixed
                  // =======================
                  // page gestion mensuelle
                  // =======================

                  calculs.mtTotalLotDetailLigneDeboursesHorsProvisions = Number(calculs.mtDernierePropositionPresta) + Number(calculs.mtTotalLotDetailLigneAvenant) + Number(calculs.mtTotalLotDetailLigneAvenantMarchePrincipal) + Number(calculs.mtTotalLotDetailLigneTransfert);
                  calculs.mtTotalLotDetailLigneBudgetGlobalAffaire = Number(calculs.mtTotalLotDetailLigneDeboursesHorsProvisions) + Number(calculs.mtTotalLotDetailLigneProvision);
                  var gestmensLotDetailMmoins1 = state.calculs.gestmensLotDetail[state.YYYYMMmoins1].filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  });
                  var gestmensLotDetailM = state.calculs.gestmensLotDetail[state.YYYYMM].filter(function (x) {
                    return x.id_lot_detail === lotsDetail.id;
                  })[0];
                  calculs.pcAvancementMmoins1 = gestmensLotDetailMmoins1 && gestmensLotDetailMmoins1.length > 0 ? gestmensLotDetailMmoins1[gestmensLotDetailMmoins1.length - 1].pc_avancement_cumule : 0;
                  calculs.pcAvancementCumule = gestmensLotDetailM && gestmensLotDetailM.pc_avancement_cumule ? gestmensLotDetailM.pc_avancement_cumule : calculs.pcAvancementMmoins1;
                  calculs.pcAvancementM = calculs.pcAvancementCumule > 0 ? Number(calculs.pcAvancementCumule) - Number(calculs.pcAvancementMmoins1) : 0;
                  calculs.mtBudgetDebloque = Number((calculs.mtTotalLotDetailLigneDeboursesHorsProvisions * calculs.pcAvancementCumule / 100).toFixed(2));
                  /*
                  const mtFactureMmois1 = gestmensLotDetailMmoins1 && gestmensLotDetailMmoins1.length > 0 ? gestmensLotDetailMmoins1.mt_facture : ''
                  calculs.mtFacture = gestmensLotDetailM && gestmensLotDetailM.mt_facture ? gestmensLotDetailM.mt_facture : mtFactureMmois1
                  */

                  calculs.mtFacture = gestmensLotDetailM && gestmensLotDetailM.mt_facture ? gestmensLotDetailM.mt_facture : '';
                  calculs.mtEngage = Number(calculs.mtBudgetDebloque) - Number(calculs.mtFacture); // ================================================================
                  // Mémorisation des calculs au niveau de la ligne de détail du lot
                  // ================================================================

                  state.calculs.lotsDetail[index] = calculs; // ================================================================
                  // Recherche des données des déboursés indirects pour le rapport des Déboursés indirects

                  var infos = state.societe.deboursesIndirects ? JSON.parse(state.societe.deboursesIndirects) : null;

                  if (lotsDetail.id_debourseIndirect > 0 && infos) {
                    var group = 'Sans nom';
                    var grp = infos.find(function (x) {
                      return x.id_debourseIndirect === lotsDetail.id_debourseIndirect;
                    });

                    if (grp) {
                      group = grp.group_debourseIndirect !== null ? grp.group_debourseIndirect : grp.titre_debourseIndirect;
                    }

                    if (!tmpCalculsLotsDetailDeboursesIndirects[group]) {
                      tmpCalculsLotsDetailDeboursesIndirects[group] = {};
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetInitial = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetMoisM = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].pcAvancement = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetDebloqueMoisM = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtDepensesComptabilisees = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtEngages = 0;
                      tmpCalculsLotsDetailDeboursesIndirects[group].mtSoldeBudget = 0;
                    }

                    tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetInitial += Number(calculs.mtDernierePropositionPresta);
                    tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetMoisM += Number(calculs.mtTotalLotDetailLigneBudgetGlobalAffaire);
                    tmpCalculsLotsDetailDeboursesIndirects[group].pcAvancement += Number(calculs.mtTotalLotDetailLigneBudgetGlobalAffaire) !== 0 ? Number(calculs.mtBudgetDebloque) / Number(calculs.mtTotalLotDetailLigneBudgetGlobalAffaire) : 0;
                    tmpCalculsLotsDetailDeboursesIndirects[group].mtBudgetDebloqueMoisM += Number(calculs.mtBudgetDebloque);
                    tmpCalculsLotsDetailDeboursesIndirects[group].mtDepensesComptabilisees += Number(calculs.mtFacture);
                    tmpCalculsLotsDetailDeboursesIndirects[group].mtEngages += Number(calculs.mtEngage);
                    tmpCalculsLotsDetailDeboursesIndirects[group].mtSoldeBudget += Number(calculs.mtTotalLotDetailLigneBudgetGlobalAffaire) - Number(calculs.mtBudgetDebloque);
                  }
                }); // **************** [2] calculs de sous totaux de chaque colonne en bas de chaque lot (ligne s/total) ***************************

                state.lots.forEach(function (lots, index) {
                  var lotsDetail = state.calculs.lotsDetail.filter(function (x) {
                    return x.id_lot === lots.id;
                  });
                  var calculs = {};
                  calculs.id = lots.id;
                  calculs.libelle = lots.libelle;
                  calculs.ordre = lots.ordre; // ========================================
                  // page vente initiale: s/total des colonnes
                  // ========================================

                  calculs.mtTotalLotDebourseEtude = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtDebourseEtude);
                  }, 0); // =============================================
                  // page objectifs déboursés: s/total des colonnes
                  // =============================================

                  calculs.mtTotalLotObjDebourseExec = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtObjDebourseExec);
                  }, 0); // ========================================
                  // page budget affaire: s/total des colonnes
                  // ========================================

                  calculs.mtTotalLotDernierePropositionPresta = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtDernierePropositionPresta);
                  }, 0);
                  calculs.mtTotalLotEcart = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtEcart);
                  }, 0).toFixed(2); // =========================================================================
                  // page avenants: s/total de chaque colonne & de la colonne "total avenant"
                  // =========================================================================

                  calculs.mtTotalLotColonneAvenant = [];
                  lotsDetail.forEach(function (row) {
                    row.mtAvenant.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneAvenant[col.num_colonne]) {
                        calculs.mtTotalLotColonneAvenant[col.num_colonne] = Number(col.mt_avenant);
                      } else {
                        calculs.mtTotalLotColonneAvenant[col.num_colonne] += Number(col.mt_avenant);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneAvenant = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneAvenant);
                  }, 0);
                  calculs.mtTotalLotColonneAvenantMarchePrincipal = [];
                  lotsDetail.forEach(function (row) {
                    row.mtAvenantMarchePrincipal.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneAvenantMarchePrincipal[col.num_colonne]) {
                        calculs.mtTotalLotColonneAvenantMarchePrincipal[col.num_colonne] = Number(col.mt_avenant);
                      } else {
                        calculs.mtTotalLotColonneAvenantMarchePrincipal[col.num_colonne] += Number(col.mt_avenant);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneAvenantMarchePrincipal = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneAvenantMarchePrincipal);
                  }, 0); // =========================================================================
                  // page budget complémentaires: s/total de chaque colonne & de la colonne "total budget comp"
                  // =========================================================================

                  calculs.mtTotalLotColonneBudgetComp = [];
                  lotsDetail.forEach(function (row) {
                    row.mtBudgetComp.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneBudgetComp[col.num_colonne]) {
                        calculs.mtTotalLotColonneBudgetComp[col.num_colonne] = Number(col.mt_budget_complementaire);
                      } else {
                        calculs.mtTotalLotColonneBudgetComp[col.num_colonne] += Number(col.mt_budget_complementaire);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneBudgetComp = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneBudgetComp);
                  }, 0); // =========================================================================
                  // page provisions: s/total de chaque colonne & de la colonne "total provision"
                  // =========================================================================

                  calculs.mtTotalLotColonneProvision = [];
                  lotsDetail.forEach(function (row) {
                    row.mtProvision.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneProvision[col.num_colonne]) {
                        calculs.mtTotalLotColonneProvision[col.num_colonne] = Number(col.mt_provision);
                      } else {
                        calculs.mtTotalLotColonneProvision[col.num_colonne] += Number(col.mt_provision);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneProvision = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneProvision);
                  }, 0); // =========================================================================
                  // page provisions pour risques: s/total de chaque colonne & de la colonne "total provision risque"
                  // =========================================================================

                  calculs.mtTotalLotColonneProvisionRisque = [];
                  lotsDetail.forEach(function (row) {
                    row.mtProvisionRisque.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneProvisionRisque[col.num_colonne]) {
                        calculs.mtTotalLotColonneProvisionRisque[col.num_colonne] = Number(col.mt_provisionrisque);
                      } else {
                        calculs.mtTotalLotColonneProvisionRisque[col.num_colonne] += Number(col.mt_provisionrisque);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneProvisionRisque = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneProvisionRisque);
                  }, 0); // =========================================================================
                  // page transferts: s/total de chaque colonne & de la colonne "total transfert"
                  // =========================================================================

                  calculs.mtTotalLotColonneTransfert = [];
                  lotsDetail.forEach(function (row) {
                    row.mtTransfert.forEach(function (col) {
                      if (!calculs.mtTotalLotColonneTransfert[col.num_colonne]) {
                        calculs.mtTotalLotColonneTransfert[col.num_colonne] = Number(col.mt_transfert);
                      } else {
                        calculs.mtTotalLotColonneTransfert[col.num_colonne] += Number(col.mt_transfert);
                      }
                    });
                  });
                  calculs.mtTotalLotLigneTransfert = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtTotalLotDetailLigneTransfert);
                  }, 0); // =========================================================================
                  // gestion mensuelle: s/total des colonnes
                  // =========================================================================

                  calculs.mtTotalLotColonneDeboursesHorsProvision = Number(calculs.mtTotalLotDernierePropositionPresta) + Number(calculs.mtTotalLotLigneAvenant) + Number(calculs.mtTotalLotLigneAvenantMarchePrincipal) + Number(calculs.mtTotalLotLigneTransfert);
                  calculs.mtTotalLotColonneBudgetGlobalAffaire = Number(calculs.mtTotalLotColonneDeboursesHorsProvision) + Number(calculs.mtTotalLotLigneProvision);
                  calculs.mtTotalLotBudgetDebloque = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtBudgetDebloque);
                  }, 0);
                  calculs.mtTotalLotFacture = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtFacture);
                  }, 0);
                  calculs.mtTotalLotEngage = lotsDetail.reduce(function (prev, cur) {
                    return prev + Number(cur.mtEngage);
                  }, 0); // ========================================
                  // mémorisation des calculs au niveau du lot
                  // ========================================

                  state.calculs.lots[index] = calculs;
                }); // ********************** [3] calcul des totaux generaux de chaque colonne en bas de page au niveau de l'affaire *******************************

                var calculs = {}; // ===================
                // page vente initiale
                // ===================

                calculs.mtTotalGeneralVenteFinaleHT = mtTotalGeneralVenteInitiale - mtRemiseCommerciale;
                calculs.mtTotalGeneralDebourseEtudeHT = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotDebourseEtude);
                }, 0);
                calculs.mtTotalGeneralMargeBruteInitialeHT = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralDebourseEtudeHT;
                calculs.pcTotalGeneralInitialeMargeBrute = calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtTotalGeneralMargeBruteInitialeHT / calculs.mtTotalGeneralVenteFinaleHT : 0;
                calculs.coefRemiseCommerciale = coefRemiseCommerciale.toFixed(4); // ========================
                // page objectifs déboursés
                // ========================
                // voir plus bas - suite évolutions avec l'ajout de la colonne provisions il faut mtTotalGeneralProvisions
                // ===================
                // page budget affaire
                // ===================
                // voir plus bas - suite évolutions avec l'ajout de la colonne provisions il faut mtTotalGeneralProvisions
                // ===============
                // page avenants
                // ===============

                calculs.mtTotalGeneralColonneAvenant = [];
                calculs.dateColonneAvenant = [];
                calculs.colonneAvenant = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtAvenant) {
                    row.mtAvenant.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneAvenant[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneAvenant[col.num_colonne] = Number(col.mt_avenant);
                      } else {
                        calculs.mtTotalGeneralColonneAvenant[col.num_colonne] += Number(col.mt_avenant);
                      }

                      calculs.dateColonneAvenant[col.num_colonne] = col.date_creation;
                      calculs.colonneAvenant[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneAvenant = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneAvenant);
                }, 0);
                calculs.colonneAvenantMarchePrincipalEntete = [];
                state.calculs.avenantsMarchePrincipalEntetes.forEach(function (row, index) {
                  calculs.colonneAvenantMarchePrincipalEntete[index + 1] = {
                    date_creation: row.date_creation,
                    periode_gestmens: (0, _utils.recadragePeriodeGestMens)(row.periode_gestmens)
                  };
                });
                calculs.mtTotalGeneralColonneAvenantMarchePrincipal = [];
                calculs.dateColonneAvenantMarchePrincipal = [];
                calculs.colonneAvenantMarchePrincipal = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtAvenantMarchePrincipal) {
                    row.mtAvenantMarchePrincipal.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneAvenantMarchePrincipal[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneAvenantMarchePrincipal[col.num_colonne] = Number(col.mt_avenant);
                      } else {
                        calculs.mtTotalGeneralColonneAvenantMarchePrincipal[col.num_colonne] += Number(col.mt_avenant);
                      }

                      calculs.dateColonneAvenantMarchePrincipal[col.num_colonne] = col.date_creation;
                      calculs.colonneAvenantMarchePrincipal[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneAvenantMarchePrincipal = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneAvenantMarchePrincipal);
                }, 0); // ===============
                // page budget complémentaire
                // ===============

                calculs.mtTotalGeneralColonneBudgetComp = [];
                calculs.dateColonneBudgetComp = [];
                calculs.colonneBudgetComp = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtBudgetComp) {
                    row.mtBudgetComp.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneBudgetComp[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneBudgetComp[col.num_colonne] = Number(col.mt_budget_complementaire);
                      } else {
                        calculs.mtTotalGeneralColonneBudgetComp[col.num_colonne] += Number(col.mt_budget_complementaire);
                      }

                      calculs.dateColonneBudgetComp[col.num_colonne] = col.date_creation;
                      calculs.colonneBudgetComp[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneBudgetComp = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneBudgetComp);
                }, 0); // ===============
                // page provision
                // ===============

                calculs.mtTotalGeneralColonneProvision = [];
                calculs.dateColonneProvision = [];
                calculs.colonneProvision = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtProvision) {
                    row.mtProvision.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneProvision[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneProvision[col.num_colonne] = Number(col.mt_provision);
                      } else {
                        calculs.mtTotalGeneralColonneProvision[col.num_colonne] += Number(col.mt_provision);
                      }

                      calculs.dateColonneProvision[col.num_colonne] = col.date_creation;
                      calculs.colonneProvision[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneProvision = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneProvision);
                }, 0); // ===============
                // page provision pour risques
                // ===============

                calculs.mtTotalGeneralColonneProvisionRisque = [];
                calculs.dateColonneProvisionRisque = [];
                calculs.colonneProvisionRisque = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtProvisionRisque) {
                    row.mtProvisionRisque.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneProvisionRisque[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneProvisionRisque[col.num_colonne] = Number(col.mt_provisionrisque);
                      } else {
                        calculs.mtTotalGeneralColonneProvisionRisque[col.num_colonne] += Number(col.mt_provisionrisque);
                      }

                      calculs.dateColonneProvisionRisque[col.num_colonne] = col.date_creation;
                      calculs.colonneProvisionRisque[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneProvisionRisque = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneProvisionRisque);
                }, 0); // ===============
                // page transfert
                // ===============

                calculs.mtTotalGeneralColonneTransfert = [];
                calculs.dateColonneTransfert = [];
                calculs.colonneTransfert = [];
                state.calculs.lotsDetail.forEach(function (row) {
                  if (row && row.mtTransfert) {
                    row.mtTransfert.forEach(function (col) {
                      if (!calculs.mtTotalGeneralColonneTransfert[col.num_colonne]) {
                        calculs.mtTotalGeneralColonneTransfert[col.num_colonne] = Number(col.mt_transfert);
                      } else {
                        calculs.mtTotalGeneralColonneTransfert[col.num_colonne] += Number(col.mt_transfert);
                      }

                      calculs.dateColonneTransfert[col.num_colonne] = col.date_creation;
                      calculs.colonneTransfert[col.num_colonne] = {
                        date_creation: col.date_creation,
                        periode_gestmens: (0, _utils.recadragePeriodeGestMens)(col.periode_gestmens)
                      };
                    });
                  }
                });
                calculs.mtTotalGeneralLigneTransfert = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotLigneTransfert);
                }, 0); // =======================
                // page gestion mensuelle
                // =======================

                calculs.mtTotalGeneralDesMarchesInitiaux = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotDernierePropositionPresta);
                }, 0);
                calculs.mtTotalGeneralAvenants = calculs.mtTotalGeneralLigneAvenant;
                calculs.mtTotalGeneralAvenantsMarchePrincipal = calculs.mtTotalGeneralLigneAvenantMarchePrincipal;
                calculs.mtTotalGeneralTransferts = calculs.mtTotalGeneralLigneTransfert;
                calculs.mtTotalGeneralDeboursesHorsProvisions = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotColonneDeboursesHorsProvision);
                }, 0);
                calculs.mtTotalGeneralDeboursesHorsProvisions = Number(Number(calculs.mtTotalGeneralDeboursesHorsProvisions).toFixed(2));
                calculs.mtTotalGeneralProvisions = calculs.mtTotalGeneralLigneProvision + calculs.mtTotalGeneralLigneBudgetComp;
                calculs.mtTotalGeneralAleas = calculs.mtTotalGeneralLigneProvision;
                calculs.mtTotalGeneralProvisionsRisques = calculs.mtTotalGeneralLigneProvisionRisque;
                calculs.mtTotalGeneralBudgetGlobalAffaire = Number(calculs.mtTotalGeneralDeboursesHorsProvisions) + Number(calculs.mtTotalGeneralProvisions);
                calculs.mtTotalGeneralBudgetDebloque = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotBudgetDebloque);
                }, 0);
                calculs.mtTotalGeneralFacture = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotFacture);
                }, 0);
                calculs.mtTotalGeneralEngage = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotEngage);
                }, 0);
                calculs.pcAvancementGlobal = calculs.mtTotalGeneralBudgetGlobalAffaire !== 0 ? calculs.mtTotalGeneralBudgetDebloque / calculs.mtTotalGeneralBudgetGlobalAffaire : 0;
                calculs.pcAvancementGlobal = Number(Number(calculs.pcAvancementGlobal).toFixed(4)); // =======================
                // page objectifs déboursés
                // =======================

                calculs.mtTotalGeneralTotalVenteInitialeHT = mtTotalGeneralVenteInitiale;
                calculs.mtTotalGeneralObjDebourseExec = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotObjDebourseExec);
                }, 0);
                calculs.mtTotalGeneralDeboursesObjectifsHT = calculs.mtTotalGeneralObjDebourseExec;
                calculs.mtTotalGeneralMargeBruteEtudeCommerciale = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralDebourseEtudeHT;
                calculs.pcTotalGeneralMargeBruteEtudeCommerciale = calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtTotalGeneralMargeBruteEtudeCommerciale / calculs.mtTotalGeneralVenteFinaleHT : 0; // 29/06/2023
                // calculs.mtTotalGeneralMargeBruteObjectifsDeboursesHT = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralObjDebourseExec - calculs.mtTotalGeneralProvisions

                var mtTotalAleasObjDebours = state.calculs.provisions.reduce(function (prev, cur) {
                  return prev + (cur.etape_origine === 2 ? Number(cur.mt_provision) : 0);
                }, 0);
                calculs.mtTotalGeneralMargeBruteObjectifsDeboursesHT = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralObjDebourseExec - mtTotalAleasObjDebours;
                calculs.pcTotalGeneralMargeBruteObjectifsDeboursesHT = calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtTotalGeneralMargeBruteObjectifsDeboursesHT / calculs.mtTotalGeneralVenteFinaleHT : ''; // =======================
                // page budget affaire
                // =======================

                calculs.mtTotalGeneralDernierePropositionPresta = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotDernierePropositionPresta);
                }, 0);
                /* 20/06/2023
                calculs.mtTotalGeneralBudgetFinalHT = calculs.mtTotalGeneralDernierePropositionPresta + calculs.mtTotalGeneralProvisions
                calculs.mtTotalGeneralBudgetObjectifInitialHT = calculs.mtTotalGeneralObjDebourseExec + calculs.mtTotalGeneralProvisions
                */

                var mtTotalAleasBudgetAffaire = mtTotalAleasObjDebours + state.calculs.provisions.reduce(function (prev, cur) {
                  return prev + (cur.etape_origine === 3 ? Number(cur.mt_provision) : 0);
                }, 0);
                calculs.mtTotalGeneralBudgetFinalHT = calculs.mtTotalGeneralDernierePropositionPresta + mtTotalAleasBudgetAffaire;
                calculs.mtTotalGeneralBudgetObjectifInitialHT = calculs.mtTotalGeneralObjDebourseExec + mtTotalAleasBudgetAffaire;
                calculs.mtObjectifInitialMB = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralBudgetObjectifInitialHT;
                calculs.mtMBFinale = calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralBudgetFinalHT;
                calculs.pcMBFinale = calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtMBFinale / calculs.mtTotalGeneralVenteFinaleHT : 0;
                calculs.mtTotalGeneralEcart = state.calculs.lots.reduce(function (prev, cur) {
                  return prev + Number(cur.mtTotalLotEcart);
                }, 0).toFixed(2);
                calculs.pcObjectifInitialMB = calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtObjectifInitialMB / calculs.mtTotalGeneralVenteFinaleHT : 0; // -- Données issues de la facturation ------
                // Facturation client : Cumul M

                calculs.mtCumulFacturationClientM = state.calculs.factures[state.YYYYMMmoins1] ? state.calculs.factures[state.YYYYMMmoins1].reduce(function (prev, cur) {
                  return prev + Number(cur.montant_ht);
                }, 0) : 0; // Facturation client : Cumul M-1

                calculs.mtCumulFacturationClientMmoins1 = state.calculs.factures[state.YYYYMMmoins2] ? state.calculs.factures[state.YYYYMMmoins2].reduce(function (prev, cur) {
                  return prev + Number(cur.montant_ht);
                }, 0) : 0; // Facturation client pour le mois

                calculs.mtFacturationClient = calculs.mtCumulFacturationClientM - calculs.mtCumulFacturationClientMmoins1; // -- synthese pied de page ------

                calculs.mtFactureProrata = Number(state.calculs.gestmensAffaire[state.YYYYMM].mt_facture_prorata) || 0;
                calculs.mtPrevFactureProrata = Number(state.calculs.gestmensAffaire[state.YYYYMM].mt_prev_facture_prorata) || 0;
                calculs.mtFactureDiverse = Number(state.calculs.gestmensAffaire[state.YYYYMM].mt_facture_diverse) || 0;
                calculs.mtPrevFactureDiverse = Number(state.calculs.gestmensAffaire[state.YYYYMM].mt_prev_facture_diverse) || 0; // -- Données issues de la facturation ------
                // Révision actualisation : Cumul M

                calculs.mtRevisionActu = state.calculs.factures[state.YYYYMM].reduce(function (prev, cur) {
                  return prev + Number(cur.rev_actu);
                }, 0);
                calculs.mtPrevRevisionActu = Number(state.calculs.gestmensAffaire[state.YYYYMM].mt_prev_revision_actu) || 0;
                calculs.mtRappelMb1 = calculs.mtTotalGeneralMargeBruteInitialeHT;
                calculs.pcRappelMb1 = calculs.pcTotalGeneralInitialeMargeBrute;
                calculs.mtRappelMb2 = calculs.mtTotalGeneralMargeBruteObjectifsDeboursesHT; // 29/06/2023 calculs.mtObjectifInitialMB

                calculs.pcRappelMb2 = calculs.pcTotalGeneralMargeBruteObjectifsDeboursesHT; // 26/06/2023 calculs.pcObjectifInitialMB

                calculs.mtRappelMb3 = calculs.mtMBFinale; // 29/06/2023 calculs.mtTotalGeneralVenteFinaleHT - calculs.mtTotalGeneralDernierePropositionPresta

                calculs.pcRappelMb3 = calculs.pcMBFinale; // 29/06/2023 calculs.mtTotalGeneralVenteFinaleHT !== 0 ? calculs.mtRappelMb3 / calculs.mtTotalGeneralVenteFinaleHT : 0

                calculs.mtgestmensAvtMPrincTotalAcceptes = state.calculs.avenantsMarchePrincipalEntetes.reduce(function (prev, cur) {
                  return prev + Number(cur.mt_accepte);
                }, 0);
                calculs.mtgestmensAvtMPrincTotalDebourses = state.calculs.avenantsMarchePrincipalEntetes.reduce(function (prev, cur) {
                  return prev + Number(cur.mt_debourse);
                }, 0);
                calculs.mtgestmensAvtMPrincTotalMB = calculs.mtgestmensAvtMPrincTotalAcceptes - calculs.mtgestmensAvtMPrincTotalDebourses;
                calculs.pcgestmensAvtMPrincTotalMB = calculs.mtgestmensAvtMPrincTotalAcceptes !== 0 ? calculs.mtgestmensAvtMPrincTotalMB / calculs.mtgestmensAvtMPrincTotalAcceptes : 0;
                calculs.mtTotalMarche = calculs.mtTotalGeneralVenteFinaleHT + calculs.mtgestmensAvtMPrincTotalAcceptes; // calculs.mtTotalGeneralAvenantsMarchePrincipal

                calculs.mtFdcPmPrixDeVente = calculs.mtTotalMarche;
                calculs.mtFdcMargeBrute1 = calculs.mtFdcPmPrixDeVente - calculs.mtTotalGeneralBudgetGlobalAffaire; // <SFI 17/12/2024>
                // calculs.mtMargeBrute1 = calculs.mtFdcMargeBrute1 * calculs.pcAvancementGlobal

                if (calculs.mtTotalMarche === 0) {
                  var mtTotalGeneralCumulDepenses = Number(calculs.mtTotalGeneralFacture) + Number(calculs.mtTotalGeneralEngage) + Number(calculs.mtTotalGeneralLigneProvisionRisque);
                  calculs.mtMargeBrute1 = -mtTotalGeneralCumulDepenses;
                } else {
                  calculs.mtMargeBrute1 = calculs.mtFdcMargeBrute1 * calculs.pcAvancementGlobal;
                } // </SFI 17/12/2024>


                calculs.pcMargeBrute1 = calculs.mtFdcPmPrixDeVente !== 0 ? calculs.mtFdcMargeBrute1 / calculs.mtFdcPmPrixDeVente : 0;
                calculs.mtPmPrixDeVente = calculs.mtTotalGeneralBudgetDebloque + calculs.mtMargeBrute1 + calculs.mtFactureProrata + calculs.mtFactureDiverse + calculs.mtRevisionActu || 0;
                calculs.pcPmPrixDeVente = calculs.mtFdcPmPrixDeVente !== 0 ? calculs.mtPmPrixDeVente / calculs.mtFdcPmPrixDeVente : 0;
                calculs.mtMargeBrute2 = calculs.mtFactureProrata + calculs.mtFactureDiverse + calculs.mtRevisionActu - calculs.mtTotalGeneralProvisionsRisques;
                calculs.mtFdcMargeBrute2 = calculs.mtMargeBrute2;
                calculs.mtMargeBruteTotale = calculs.mtMargeBrute1 + calculs.mtMargeBrute2;
                calculs.mtFdcMargeBruteTotale = calculs.mtFdcMargeBrute1 + calculs.mtFdcMargeBrute2;
                calculs.pcMargeBruteTotale = calculs.mtFdcPmPrixDeVente !== 0 ? calculs.mtFdcMargeBruteTotale / calculs.mtFdcPmPrixDeVente : 0;
                calculs.mtEcartMbBudgetExec = calculs.mtFdcMargeBruteTotale - calculs.mtRappelMb3;
                calculs.pcEcartMbBudgetExec = calculs.pcPmPrixDeVente !== 0 ? calculs.mtEcartMbBudgetExec / calculs.mtFdcPmPrixDeVente : 0;
                calculs.mtMargeBruteTotaleMmoins1 = state.calculsMmoins1 && state.calculsMmoins1.mtMargeBruteTotale ? Number(state.calculsMmoins1.mtMargeBruteTotale) : 0;
                calculs.mtFdcMargeBruteTotaleMmoins1 = state.calculsMmoins1.mtFdcMargeBruteTotale ? state.calculsMmoins1.mtFdcMargeBruteTotale : 0;
                calculs.mtEcartMargeBruteTotaleMmoins1M = calculs.mtMargeBruteTotale - calculs.mtMargeBruteTotaleMmoins1;
                calculs.mtFdcEcartMargeBruteTotalMmoins1M = calculs.mtFdcMargeBruteTotale - calculs.mtFdcMargeBruteTotaleMmoins1;
                calculs.id_affaire = state.affaire.id;
                calculs.YYYYMM = state.YYYYMM;
                calculs.YYYYMMmoins1 = state.YYYYMMmoins1;
                calculs.YYYYMMmoins2 = state.YYYYMMmoins2; // pour le rapport des déboursés indirects

                calculs.deboursesIndirects = Object.assign({}, tmpCalculsLotsDetailDeboursesIndirects); // ===============================================
                // mémorisation des calculs au niveau de l'affaire
                // ===============================================

                state.calculs.affaire = calculs; // ==================================================
                // consolidation des montants au niveau de l'affaire
                // ==================================================

                state.affaire.mt_total_vente_initiale = mtTotalGeneralVenteInitiale;
                state.affaire.mt_remise_commerciale = mtRemiseCommerciale;

                if (params && params.modeEdit === false) {
                  // nombre de colonne à afficher dans la page des avenants
                  state.nbColAvenant = state.calculs.avenants.length > 0 ? Math.max.apply(Math, state.calculs.avenants.map(function (o) {
                    return o.num_colonne;
                  })) : 0; // nombre de colonne à afficher dans la page des avenants marche principal
                  // on prends le nombre d'entete et pas le nombre d'avenants mprinc car il peut avoir des entetes sans avenants mprinc
                  // state.nbColAvenantMarchePrincipal = state.calculs.avenantsMarchePrincipal.length > 0 ? Math.max.apply(Math, state.calculs.avenantsMarchePrincipal.map(function (o) { return o.num_colonne })) : 0

                  state.nbColAvenantMarchePrincipal = state.calculs.avenantsMarchePrincipalEntetes.length || 0; // console.log(`state.nbColAvenant = ${state.nbColAvenant}, state.nbColAvenantMarchePrincipal = ${state.nbColAvenantMarchePrincipal}`)
                  // nombre de colonne à afficher dans la page des budget complémentaires

                  state.nbColBudgetComp = state.calculs.budgetscomp.length > 0 ? Math.max.apply(Math, state.calculs.budgetscomp.map(function (o) {
                    return o.num_colonne;
                  })) : 0; // nombre de colonne à afficher dans la page des provisions

                  state.nbColProvision = state.calculs.provisions.length > 0 ? Math.max.apply(Math, state.calculs.provisions.map(function (o) {
                    return o.num_colonne;
                  })) : 0; // nombre de colonne à afficher dans la page des provisions pour risques

                  state.nbColProvisionRisque = state.calculs.provisionsRisques.length > 0 ? Math.max.apply(Math, state.calculs.provisionsRisques.map(function (o) {
                    return o.num_colonne;
                  })) : 0; // nombre de colonne à afficher dans la page des transferts

                  state.nbColTransfert = state.calculs.transferts.length > 0 ? Math.max.apply(Math, state.calculs.transferts.map(function (o) {
                    return o.num_colonne;
                  })) : 0;
                } // console.log(state.calculs)


                dispatch('saveToDb', lastGestMens);
                resolve();
              }));

            case 80:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function calcul(_x3, _x4) {
      return _calcul.apply(this, arguments);
    }

    return calcul;
  }(),
  // sauvegarde les résultats calculés dans la base de données pour être réutilisé dans le reporting ou ailleurs
  saveToDb: function saveToDb(_ref40, lastGestMens) {
    var dispatch = _ref40.dispatch;
    return new Promise(function (resolve, reject) {
      if (state.YYYYMM && state.YYYYMM === lastGestMens) {
        // on ne sauvegarde que pour la dernière période en cours (et pas les précedentes)
        // constitution de l'objet avec les données à sauvegarder
        var data = {
          id_affaire: state.affaire.id,
          anneemois: state.YYYYMM,
          data: JSON.stringify(state.calculs.affaire)
        };
        apiAffaireCalculs.save(data).then(function (results) {
          console.log('saveToDb', state.YYYYMM);
          resolve(results);
        }).catch(function (error) {
          reject(error);
        });
      }
    });
  }
};
var getters = {
  // --- Affaires
  getAffaireList: function getAffaireList(state) {
    return state.affaires;
  },
  getAffaire: function getAffaire(state) {
    return state.affaire;
  }
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
exports.default = _default;